import { render } from "./ai-popup.vue?vue&type=template&id=335e3952"
import script from "./ai-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "335e3952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('335e3952', __exports__)) {
    api.reload('335e3952', __exports__)
  }
  
  module.hot.accept("./ai-popup.vue?vue&type=template&id=335e3952", () => {
    api.rerender('335e3952', render)
  })

}


export default __exports__